module.exports = __webpack_public_path__ + "img/u1009.3240614c.svg";